// extracted by mini-css-extract-plugin
export default {"wrapper":"Accordion_wrapper__om1eJ","container":"Accordion_container__ObkQ4","title":"Accordion_title__+idK1","item":"Accordion_item__d0C7j","load-more":"Accordion_load-more__TASjl"};